module.exports = __webpack_public_path__ + "img/deposit_paid_icon.865e4497.svg";